import * as React from "react";
// import { pure } from 'recompose';
// import * as Scrollbars from 'react-custom-scrollbars';
// import * as Lodash from 'lodash';
// import *as cx from 'classnames';
import * as i18next from "i18next";
// import * as Utils from '@Cyclope-Utils/index';
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
import DatePicker from "@tunnel-components/@sharded/@widgets/dataPicker";
// import CheckBoxNormal from '@tunnel-components/@sharded/widgets/forms/input/checkbox/normal/component';
// import * as shordid from 'shortid';
import * as Styled from "@tunnel-components/@sharded/@styled/cart";
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import SelectMultipleGrid from "@tunnel-components/@sharded/@widgets/filtre-multiple";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const {
    selectedValueName,
    errorDateRange,
    onEndDateChange,
    onGetValue,
    startDate,
    endDate,
    onStartDateChange,
    isOpen,
    onClose,
    onSearchSubmitFilter,
    cameras,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-datepicker
   * @name react-custom-scrollbars
   * @name lodash
   * @name i18next
   * @name react-datepicker
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer isVisible={isOpen}>
      <StyledComponent.ModalContainerInsider
        isVisible={isOpen}
        style={{
          width: "540px",
          backgroundColor: "transparent",
          overflow: "visible",
        }}
      >
        <div className="cart-box-incidents">
          <div className="cart-incident">
            <div className="box-header-custom">
              <div className="box-center-display">
                <div className="left part-left">
                  <span>{i18next.t("filtres")}</span>
                </div>
                <div className="left part-left" style={{ textAlign: "right" }}>
                  <div className="la-croix" onClick={onClose} />
                </div>
              </div>
            </div>
            <Styled.CartContainer>
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  margin: "20px auto 0",
                }}
              >
                <h2 style={{ marginBottom: "15px", color: "#007ADF" }}>
                  {i18next.t("date")} :{" "}
                </h2>
                <div className="dtePicker left">
                  <DatePicker
                    placeholder={i18next.t("date de debut")}
                    error={errorDateRange}
                    selectedValue={startDate}
                    onChangeSelected={onStartDateChange}
                  />
                </div>
                <div className="dtePicker left">
                  <DatePicker
                    placeholder={i18next.t("date de fin")}
                    error={errorDateRange}
                    selectedValue={endDate}
                    onChangeSelected={onEndDateChange}
                  />
                </div>
              </div>
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  margin: "20px 0 0",
                }}
              >
                <h2 style={{ marginBottom: "15px", color: "#007ADF" }}>
                  {i18next.t("camera")}:{" "}
                </h2>
                <div className="dtePickers " style={{ clear: "none" }}>
                  <SelectMultipleGrid
                    selectedValueProps={selectedValueName}
                    selectedOptions={cameras}
                    onGetSomeString={onGetValue}
                    placeholder={i18next.t("saisissez votre recherche")}
                  />
                </div>
              </div>
            </Styled.CartContainer>
            <Styled.CartContainer>
              <div className="modalBtn" style={{ clear: "both" }}>
                <span
                  className="btnSecondary "
                  style={{ overflow: "visible", border: "none" }}
                  onClick={onClose}
                >
                  {i18next.t("annuler")}
                </span>
                <span
                  className="btnPrimary "
                  style={{ overflow: "visible" }}
                  onClick={onSearchSubmitFilter}
                >
                  {" "}
                  {i18next.t("envoyer")}
                </span>
              </div>
            </Styled.CartContainer>
          </div>
        </div>
      </StyledComponent.ModalContainerInsider>
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={errorDateRange}
        someTextSuccees={i18next.t("les champs date sont invalides")}
      />
    </StyledComponent.ModalContainer>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  endDate?: any;
  errorDateRange?: any;
  onEndDateChange?: any;
  startDate?: any;
  onStartDateChange?: any;
  isOpen?: any;
  onClose?: any;
  onSearchSubmitFilter?: any;
  cameras?: any;
  label?: any;
  section?: any;
  cameraFilter?: any;
  sectionFilter?: any;
  labelFilter?: any;
  onSearchFilterCamera?: any;
  onSearchFilterLabel?: any;
  onSearchFilterSection?: any;
  qualification?: any;
  onSearchQualification?: any;
  QualificationState?: any;
  onGetValue?: any;
  selectedValueName?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/modal/filter-lapi-tmd/component.tsx